<div class="col-10 px-0">
  <h3>{{ client?.name }} Configuration Change Log</h3>
</div>
@if (!loading) {
  <div class="col-10">
    <app-pagination-header [paging]="paging" [label]="'audits'" (pageSizeChange)="onPageSizeChange($event)" />
  </div>
  <div class="audit-list-wrapper col-12">
    <table class="audit-list table table-bordered table-hover">
      <thead class="table-dark">
        <tr>
          <th>Changed At</th>
          <th>Action</th>
          <th>Option</th>
          <th>New Value</th>
          <th>Previous Value</th>
          <th>User</th>
        </tr>
      </thead>
      <tbody>
        @for (parsedAudit of parsedAudits; track parsedAudit) {
          <tr>
            <td>{{ parsedAudit.createdAt | date: 'M/d/yyyy h:mm a' }}</td>
            <td>{{ parsedAudit.action }}</td>
            <td>
              {{ parsedAudit.optionName }}
              @if (parsedAudit.changes.disabledAt[1]) {
                <div><small class="text-muted">Disabled at {{ parsedAudit.changes.disabledAt[1] | date: 'M/d/yyyy' }}</small></div>
              }
              @if (parsedAudit.changes.disabledAt[0]) {
                <div><small class="text-muted">Enabled at {{ parsedAudit.createdAt | date: 'M/d/yyyy' }}</small></div>
              }
            </td>
            <td>
              @if (parsedAudit.changes.value[1]) {
                <div
                  [innerHTML]="parsedAudit.changes.value[1]">
                </div>
              }
              @if (parsedAudit.changes.startAt[1]) {
                <div>
                  Start at {{ parsedAudit.changes.startAt[1] | date: 'M/d/yyyy h:mm a'}}
                </div>
              }
              @if (parsedAudit.changes.endAt[1]) {
                <div>
                  End at {{ parsedAudit.changes.endAt[1] | date: 'M/d/yyyy h:mm a'}}
                </div>
              }
            </td>
            <td>
              @if (parsedAudit.changes.value[0]) {
                <div
                  [innerHTML]="parsedAudit.changes.value[0]">
                </div>
              }
              @if (parsedAudit.changes.startAt[0]) {
                <div>
                  Start at {{ parsedAudit.changes.startAt[0] | date: 'M/d/yyyy h:mm a'}}
                </div>
              }
              @if (parsedAudit.changes.endAt[0]) {
                <div>
                  End at {{ parsedAudit.changes.endAt[0] | date: 'M/d/yyyy h:mm a'}}
                </div>
              }
            </td>
            <td>{{ parsedAudit.userEmail }}</td>
          </tr>
        }
      </tbody>
    </table>
    <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
  </div>
} @else {
  <mat-spinner />
}
